export default __webpack_public_path__ + "static/about-us-01-e40c2224a884cb8c4884f76a78462522.jpg";